import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  Toolbar,
  Typography,
  Modal,
  Grid,
  Backdrop,
  IconButton,
  Fade,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import useUiStore from "../../../stores/useUiStore";

import { useTreeViewApiRef } from "@mui/x-tree-view";

import TableDesMatieres from "../../chapitres/tableDesMatieres/tableDesMatieres";
import TexteGeneral from "../../chapitres/texteGeneral/texteGeneral";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  padding: "12px 0px 12px 0px",
  transition: "all 0.3s ease-in-out",
};

const voletStyle = {
  height: "80vh",

  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "5px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#00000050",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "00000050",
    backgroundColor: "#555",
    borderRadius: "2px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#888",
  },
};

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0.2 0.9 0.3 / 0);
`;

const ModalTocText = (props) => {
  const { open, handleClose, texte, contexte } = props;

  const [id, setId] = useState(texte || "intro");
  const [selectedItems, setSelectedItems] = useState(null);

  const paramsTexte = useUiStore((state) => state.paramsTexte);

  const setCurrentTexte = (subtype) => {
    useUiStore.setState({
      paramsTexte: { ...paramsTexte, currentTexte: subtype },
    });
  };

  const apiRef = useTreeViewApiRef();
  const navigate = useNavigate();

  const handleSelectedItemsChange = (event, itemId) => {
    if (itemId == null) {
      setSelectedItems(null);
    } else {
      setSelectedItems(apiRef.current.getItem(itemId));
      // setId(itemId);
      // setCurrentTexte(itemId);
      // console.log(itemId);
      navigate(`/texte/${itemId}`);
    }
  };

  const boxStyle = {
    columnCount: 4,
    columnFill: "auto",
    columnGap: "30px",
    // height: `calc(100% - 100px)`,
  };

  const handleId = (id) => {
    setId(id);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: StyledBackdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={modalStyle}>
            <Toolbar variant="dense">
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="button">
                  Le décor sculpté de la Tholos de Marmaria
                </Typography>
              </Box>

              <Box sx={{ flexGrow: 0 }}>
                <IconButton size="small" onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Toolbar>
            <Grid container direction="row" alignItems="stretch">
              <Grid item xs={3}>
                <Box sx={{ m: 1 }}>
                  <TableDesMatieres
                    // style={voletStyle}
                    setId={setId}
                    ref={apiRef}
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}
                    handleSelectedItemsChange={handleSelectedItemsChange}
                    contexte={contexte}
                  />
                </Box>
              </Grid>
              <Grid item xs={9}>
                <Box sx={{ m: 1, pr: 4, ...voletStyle }}>
                  <TexteGeneral
                    id={paramsTexte.currentTexte}
                    handleId={handleId}
                    setId={setId}
                    setSelectedItems={setSelectedItems}
                    setCurrentTexte={setCurrentTexte}
                    boxStyle={boxStyle}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default ModalTocText;
